"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deliveryToDeliveryCalendarEvent = void 0;
exports.getCalendarViewWeek = getCalendarViewWeek;
exports.getCalendarViewMonth = getCalendarViewMonth;
exports.getDaysInMonth = getDaysInMonth;
const deliveryToDeliveryCalendarEvent = (delivery, itemCategories) => {
    var _a;
    const { calendarEvent } = delivery, restDelivery = __rest(delivery, ["calendarEvent"]);
    if (!calendarEvent)
        return undefined;
    return Object.assign(Object.assign({}, calendarEvent), { delivery: Object.assign(Object.assign({}, restDelivery), { packingSlip: Object.assign(Object.assign({}, restDelivery.packingSlip), { items: restDelivery.packingSlip.items.map(i => (Object.assign(Object.assign({}, i), { category: (itemCategories === null || itemCategories === void 0 ? void 0 : itemCategories.find(c => c.id === i.categoryId)) || { id: i.categoryId, name: 'Unknown' } }))) }), inventoryOperation: restDelivery.inventoryOperation && {
                adjustments: ((_a = restDelivery.inventoryOperation) === null || _a === void 0 ? void 0 : _a.adjustments) &&
                    restDelivery.inventoryOperation.adjustments.map(a => (Object.assign(Object.assign({}, a), { item: Object.assign(Object.assign({}, a.item), { category: (itemCategories === null || itemCategories === void 0 ? void 0 : itemCategories.find(c => c.id === a.item.categoryId)) || {
                                id: a.item.categoryId,
                                name: 'Unknown',
                            } }) }))),
            } }) });
};
exports.deliveryToDeliveryCalendarEvent = deliveryToDeliveryCalendarEvent;
function getCalendarViewWeek(day, month, year) {
    const days = [];
    const date = new Date(year, month, day);
    const dayOfWeek = date.getDay();
    const startOfWeek = new Date(date);
    startOfWeek.setDate(date.getDate() - dayOfWeek);
    for (let i = 0; i < 7; i++) {
        days.push(new Date(startOfWeek));
        startOfWeek.setDate(startOfWeek.getDate() + 1);
    }
    return days;
}
function getCalendarViewMonth(month, year) {
    const prevMonth = getDaysInMonth(month === 0 ? 11 : month - 1, month === 0 ? year - 1 : year);
    const currentMonth = getDaysInMonth(month, year);
    const nextMonth = getDaysInMonth(month === 11 ? 0 : month + 1, month === 11 ? year + 1 : year);
    const firstDayOfMonth = currentMonth[0].getDay(); // 0 = Sunday, 1 = Monday, etc.
    const prevMonthDays = prevMonth.slice(firstDayOfMonth === 0 ? prevMonth.length - 6 : prevMonth.length - firstDayOfMonth);
    const nextMonthDays = nextMonth.slice(0, 42 - prevMonthDays.length - currentMonth.length);
    return [...prevMonthDays, ...currentMonth, ...nextMonthDays];
}
function getDaysInMonth(month, year) {
    const date = new Date(year, month, 1);
    const days = [];
    while (date.getMonth() === month) {
        days.push(new Date(date));
        date.setDate(date.getDate() + 1);
    }
    return days;
}
